import { Button, Typography } from "@mui/material";
import { CBFile } from "certiblok-api-manager";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import {
	ModalNavigator,
	useModalNavigator,
	useModalRoute,
} from "../../../../../../utils/components/ModalNavigator/ModalNavigator";
import { LateralDialog } from "../../../../../../utils/components/dialogs/LateralDialog";
import CertiblokIcon from "../../../../../../utils/components/icons/CertiblokIcon";
import { CertiblokDocument } from "../../../../../../utils/interfaces/Document";
import DocumentPreview from "../../../../../SingleDocument/components/DocumentPreview";
import RestoreChangeModal from "../../../../components/RestoreChangeModal";
import { cn } from "@mabi-ui/utils";

export type DocumentPreviewModalProps = {
	document?: CertiblokDocument;
	shouldRestoreDocument: boolean;
	version?: CBFile;
	changeId?: string;
	onRestore?: () => void;
	containerClassName?: string;
};

const DocumentPreviewModal = ModalNavigator.create<DocumentPreviewModalProps>(
	({ document, shouldRestoreDocument, version, changeId, onRestore, containerClassName }) => {
		const { visible } = useModalRoute();
		const { popModal, pushModal } = useModalNavigator();
		const { t } = useTranslation();

		return (
			<LateralDialog
				open={visible}
				onClose={popModal}
				DialogContainerProps={{ className: cn("bg-[#E6F4F7] md:w-[50%] md:max-w-[900px]", containerClassName) }}
				footer={
					<div
						className={clsx(
							"w-full md:bg-white flex items-center gap-3 md:px-3 md:py-4 box-border",
							shouldRestoreDocument ? "justify-between" : "justify-end"
						)}
					>
						<Button
							variant="text"
							color="secondary"
							startIcon={<CertiblokIcon name="close" color="inherit" />}
							onClick={() => popModal()}
						>
							<Typography variant="button" color={"secondary"}>
								{t("global.cancel")}
							</Typography>
						</Button>
						{shouldRestoreDocument && (
							<Button
								variant="contained"
								color={"secondary"}
								onClick={() => {
									if (changeId) {
										pushModal(
											RestoreChangeModal,
											{
												changeId: changeId,
												type: "document",
												onRestore: () => {
													onRestore?.();
												},
											},
											{ shouldHidePrev: true }
										);
									}
								}}
							>
								<Typography variant="button">{t("editRoom.restoreDocument")}</Typography>
							</Button>
						)}
					</div>
				}
			>
				<div className="flex items-center justify-center w-full min-h-full md:h-full mt-4 md:mt-0 h-[60svh]">
					<DocumentPreview
						document={document}
						currentFile={version ?? document?.lastVersionFile?.[0]}
						className="w-full min-h-full"
					/>
				</div>
			</LateralDialog>
		);
	}
);

export default DocumentPreviewModal;
